import styled from "styled-components";

const IconToggle = styled.button`
    border: none;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.375rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    &::before,
    &::after {
        content: "";
        background-color: #fff;
        height: 3px;
        width: 1.5rem;
        position: absolute;
        transition: all 0.3s ease;
    }
    &::before {
        top: ${(props) => (props.clicked ? "1.5" : "1rem")};
        transform: ${(props) => (props.clicked ? "rotate(135deg)" : "rotate(0)")};
    }
    &::after {
        top: ${(props) => (props.clicked ? "1.2" : "1.5rem")};
        transform: ${(props) => (props.clicked ? "rotate(-135deg)" : "rotate(0)")};
    }
`;

export default IconToggle;

